export enum UserRole {
  Admin = 'admin',
  Company = 'company',
  Project = 'project',
  Community = 'community',
  Superadmin = 'superAdmin',
}

export enum UserStatus {
  Pending = 'pending',
  Approved = 'approved',
}
